<script>
    import Symbol from "./Symbols.svelte";

    export let selection = "A";
    export let colors = [];
    export let strokeWidth = 8;
    export let stroke = "black";
    export let hash;
    export let symbol = 0;
</script>

{#if selection == "A"}
    <g transform="translate(0,-40)">
        
            <path d="M228.959 90.8856C195.297 149.95 204.087 222.023 228.959 271.5C258.228 216.046 263.503 149.95 228.959 90.8856Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[5]}
            {stroke} />
            <path d="M195.651 149.247C177.329 231.501 209.304 235.49 229.005 271.5C248.133 235.26 215.008 231.271 195.651 149.247Z" 
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[4]}
            {stroke} />
            <path d="M262.685 149.247C281.007 231.501 249.032 235.49 229.331 271.5C210.203 235.26 243.328 231.271 262.685 149.247Z" 
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[3]}
            {stroke}/>

    </g>
{/if}
{#if selection == "B"}
<g transform=translate(-5,-40)>
<path  d="M194.21 155.033C210.662 171.033 201.293 177.688 199.678 221.13C197.856 270.103 236.5 271.5 236.5 271.5C236.5 271.5 223.112 261.305 223.112 218.042C223.112 196.86 231.633 164.209 194.21 155.033Z"
  stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[5]}
            {stroke}
/>
<path  d="M227.807 126.911C234.345 150.186 228.219 160.948 219.693 181.601C202.65 222.889 219.693 265.236 236.502 271.5C259.554 236.173 252.015 209.913 247.28 181.601C243.619 159.715 253.106 139.077 227.807 126.911Z" 
  stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[4]}
            {stroke}
/>
<path  d="M261.17 150.725C265.423 178.689 245.273 171.78 234.965 198.994C225.967 222.751 236.503 271.5 236.503 271.5C236.503 271.5 259.431 271.5 258.1 222.129C257.327 193.496 284.063 168.037 261.17 150.725Z" 
  stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[3]}
            {stroke}
/>
</g>
{/if}
{#if selection == "C"}
    <g id="hair-3">
        
            <path  d="M266.456 100.402C233.222 136.729 263.751 168.418 229.718 214.5C218.464 186.486 224.154 100.402 266.456 100.402Z" 
            
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[5]}
            {stroke}
            />
            
            <path  d="M191.501 100.402C224.735 136.729 195.686 168.372 229.719 214.453C242.506 182.622 241.47 100.402 191.501 100.402Z" 
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[4]}
            {stroke}/>
        
    </g>
{/if}
{#if selection == "D"}
    <g id="hair-4" />
{/if}
{#if selection == "E"}
<g transform="translate(0,-20)">
    <path d="M229.41 273.59C214.008 235.248 188.075 177.659 285.695 120.047C236.085 203.265 299.421 208.648 229.41 273.59Z" 
    stroke-width={strokeWidth}
    stroke-linejoin="round"
    fill={colors[5]}
    {stroke}
    stroke-linecap="round"/>

    <path d="M229.38 273.582C281.691 222.469 238.482 188.062 229.379 96.0434C216.886 188.862 174.469 221.669 229.38 273.582Z" 
    stroke-width={strokeWidth}
    stroke-linejoin="round"
    fill={colors[4]}
    {stroke}
    stroke-linecap="round"/>
    <path d="M229.392 273.587C244.794 235.245 244.885 178.46 173.273 120.047C222.883 203.265 159.381 208.646 229.392 273.587Z" 
    stroke-width={strokeWidth}
    stroke-linejoin="round"
    fill={colors[3]}
    {stroke}
    stroke-linecap="round"/>
    </g>
{/if}
{#if selection == "F"}
    <g id="hair-6">

        <path  d="M230.055 97.071C245.457 135.413 271.39 193.002 173.77 250.614C223.38 167.396 160.043 162.013 230.055 97.071Z"     
        stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[5]}
            {stroke}
        />
        <path  d="M230.081 97.0789C177.77 148.192 220.979 182.599 230.082 274.618C242.575 181.799 284.992 148.992 230.081 97.0789Z" 
        stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[4]}
            {stroke}
        />
        <path  d="M230.069 97.0736C214.667 135.416 214.576 192.201 286.188 250.614C236.577 167.396 300.08 162.015 230.069 97.0736Z" 
        stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[3]}
            {stroke}
        />

       
    </g>
{/if}
{#if selection == "G"}
    <g id="hair-7">
        <path
            d="M198.834 205.515C198.834 248.5 256.5 253.529 256.5 200.515C256.5 147.5 234.5 80.0004 229.5 60.0004C229.5 60.0004 198.834 147 198.834 205.515Z"
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[1]}
        />
        <path
            d="M256.5 200.515C256.5 253.529 198.834 248.5 198.834 205.515C193.056 222.677 191.1 252 229.5 252C263 252 263.5 219.343 256.5 200.515Z"
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[4]}
        />
    </g>
{/if}
{#if selection == "H"}
    <g id="hair-8" transform="translate(0 -45)">
        <path
            d="M243 197.5C243 205.232 236.732 211.5 229 211.5C221.268 211.5 215 205.232 215 197.5C215 196.672 215.202 195.224 215.66 193.153C216.105 191.138 216.749 188.715 217.536 186.021C219.109 180.637 221.215 174.297 223.333 168.216C225.381 162.338 227.43 156.729 229 152.504C230.57 156.729 232.619 162.338 234.667 168.216C236.785 174.297 238.891 180.637 240.464 186.021C241.251 188.715 241.895 191.138 242.34 193.153C242.798 195.224 243 196.672 243 197.5Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[2]}
            {stroke}
        />
        <path
            d="M243 239.5C243 247.232 236.732 253.5 229 253.5C221.268 253.5 215 247.232 215 239.5C215 238.672 215.202 237.224 215.66 235.153C216.105 233.138 216.749 230.715 217.536 228.021C219.109 222.637 221.215 216.297 223.333 210.216C225.381 204.338 227.43 198.729 229 194.504C230.57 198.729 232.619 204.338 234.667 210.216C236.785 216.297 238.891 222.637 240.464 228.021C241.251 230.715 241.895 233.138 242.34 235.153C242.798 237.224 243 238.672 243 239.5Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[2]}
            {stroke}
        />
        <path
            d="M243 280.5C243 288.232 236.732 294.5 229 294.5C221.268 294.5 215 288.232 215 280.5C215 279.672 215.202 278.224 215.66 276.153C216.105 274.138 216.749 271.715 217.536 269.021C219.109 263.637 221.215 257.297 223.333 251.216C225.381 245.338 227.43 239.729 229 235.504C230.57 239.729 232.619 245.338 234.667 251.216C236.785 257.297 238.891 263.637 240.464 269.021C241.251 271.715 241.895 274.138 242.34 276.153C242.798 278.224 243 279.672 243 280.5Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[2]}
            {stroke}
        />
    </g>
{/if}
{#if selection == "I"}
    <g id="hair-9">
        <path
            d="M235.384 210.637C226.96 221.552 237.826 231.331 247.287 228.422C253.388 223.551 260.362 220.585 267.765 218.212C267.765 218.212 243.809 199.722 235.384 210.637Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[2]}
            {stroke}
        />
        <path
            d="M230.269 211.637C238.693 222.552 227.827 232.331 218.366 229.422C212.265 224.551 205.292 221.585 197.888 219.212C197.888 219.212 221.845 200.722 230.269 211.637Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[2]}
            {stroke}
        />
        <path
            d="M223.757 214.782C233.427 224.61 244.591 215.173 242.994 205.405C238.997 198.699 237.004 191.387 235.659 183.73C235.659 183.73 214.088 204.954 223.757 214.782Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[2]}
            {stroke}
        />
        <path
            d="M242.604 221.65C232.935 211.822 221.771 221.259 223.368 231.027C227.365 237.733 229.358 245.045 230.703 252.702C230.703 252.702 252.274 231.479 242.604 221.65Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[2]}
            {stroke}
        />
    </g>
{/if}
{#if selection == "J"}

<g id="Hair">
    <path id="Vector 21" d="M230.367 278.595C224.312 215.52 298.918 108.96 150.195 47.3804C220.206 131.667 160.355 213.654 230.367 278.595Z"
    stroke-width={strokeWidth}
    stroke-linejoin="round"
    fill={colors[4]}
    {stroke}/>
    <path id="Vector 22" d="M229.393 278.327L229.501 278.595C299.512 213.654 239.661 131.667 309.672 47.3804C161.295 108.817 213.852 239.644 229.393 278.327Z" 
    stroke-width={strokeWidth}
    stroke-linejoin="round"
    fill={colors[3]}
    {stroke}/>
    </g>
    
{/if}
{#if selection == "K"}
    <g id="hair-11">
        <path
            d="M258.022 171.979L246.784 206.564L276.204 227.939L239.839 227.939L228.602 262.524L217.365 227.939H181L210.42 206.564L199.182 171.979L228.602 193.354L258.022 171.979Z"
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            fill={colors[2]}
            {stroke}
            stroke-linecap="round"
        />
    </g>
{/if}

{#if selection == "L"}
    <path
        d="M225.116 259.125L226.975 217.986L212.88 221.154L213.947 176.491L242.138 170.155L230.855 202.306L248.474 198.346L225.116 259.125Z"
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        fill={colors[2]}
        {stroke}
        stroke-linecap="round"
    />
{/if}
{#if selection == "M"}
    <g id="frame">
        <circle
            id="circle_2"
            cx="229.75"
            cy="220"
            r="40"
            fill={colors[2]}
            {stroke}
            stroke-width={strokeWidth}
        />
        <g transform="translate(200 190)">
            <Symbol symbol="L" symbolColor={stroke} />
        </g>
    </g>
{/if}

{#if selection == "N"}
    <g>
        <path
            d="M195.962 241.306C195.799 241.335 195.632 241.313 195.481 241.244C195.331 241.176 195.204 241.063 195.119 240.922C195.033 240.78 194.992 240.616 195.001 240.451C195.01 240.286 195.069 240.127 195.17 239.996L227.814 177.541C228.192 176.82 228.808 176.82 229.186 177.541L261.83 239.996C261.931 240.127 261.99 240.286 261.999 240.451C262.008 240.616 261.967 240.78 261.881 240.922C261.796 241.063 261.669 241.176 261.519 241.244C261.368 241.313 261.201 241.335 261.038 241.306H195.962Z"
            fill={colors[1]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />

        <path
            d="M247.783 219.831C247.924 220.063 247.998 220.328 247.998 220.599C247.998 220.87 247.924 221.135 247.783 221.367C245.785 224.707 242.963 227.479 239.586 229.417C236.21 231.355 232.393 232.393 228.5 232.432C224.607 232.393 220.79 231.355 217.414 229.417C214.037 227.479 211.215 224.707 209.217 221.367C209.076 221.135 209.002 220.87 209.002 220.599C209.002 220.328 209.076 220.063 209.217 219.831C211.215 216.491 214.038 213.72 217.414 211.783C220.791 209.846 224.608 208.808 228.5 208.769C232.392 208.808 236.209 209.846 239.586 211.783C242.962 213.72 245.785 216.491 247.783 219.831V219.831Z"
            fill={colors[2]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
        <path
            d="M222.584 220.601C222.584 222.17 223.207 223.674 224.317 224.784C225.426 225.893 226.931 226.516 228.5 226.516C230.069 226.516 231.574 225.893 232.683 224.784C233.793 223.674 234.416 222.17 234.416 220.601C234.416 219.032 233.793 217.527 232.683 216.417C231.574 215.308 230.069 214.685 228.5 214.685C226.931 214.685 225.426 215.308 224.317 216.417C223.207 217.527 222.584 219.032 222.584 220.601Z"
            fill={colors[1]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
    </g>
{/if}

{#if selection == "O"}
    <g transform="translate(0,-25)">
        <path
            d="M298.449 403.689C258.088 355.469 288.073 293.393 276.793 243.962C265.514 194.531 218.733 176.787 194.501 169C324.202 157.693 346.976 207.683 334.228 337.194C324.273 393.111 338.059 414.892 368.769 450.714C352.248 441.983 319.666 429.037 298.449 403.689Z"
            fill={colors[4]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />

        <path
            id="Vector 23"
            d="M373.818 420.884C337.32 393.003 338.05 367.526 334.229 337.194C328.809 216.103 298.339 179.138 194.501 169L194.5 169C341.254 147.781 370.972 195.157 359.064 352.755C356.546 381.19 362.529 402.766 373.818 420.884Z"
            fill={colors[5]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />

        <path
            d="M404.308 243.962C399.529 303.362 373.818 313.94 359.064 352.755C370.972 195.157 341.254 147.781 194.5 169C318.113 88.4228 409.087 184.561 404.308 243.962Z"
            fill={colors[4]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />

        <path
            id="Vector 25"
            d="M406.42 190.321C406.42 190.321 382.373 172.564 357.37 160.451C332.368 148.337 254.998 131.763 194.501 169C246.71 115.23 360.076 76.852 406.42 190.321Z"
            fill={colors[4]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
        <path
            id="Vector 22"
            d="M396.106 265.355C398.381 226.456 381.597 188.331 341.755 165.583C296.022 139.471 244.794 139.335 194.5 169C254.997 131.763 295.183 122.114 357.37 160.451C398.272 180.03 429.959 237.424 420.631 281.417C414.812 308.863 390.537 357.058 406.419 398.84C371.086 377.154 394.152 298.772 396.106 265.355Z"
            fill={colors[5]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
    </g>
{/if}

{#if selection == "P"}

<g id="Hair" transform="translate(20,-20)">
    <path id="Vector 21" d="M295.999 162.804C250.342 206.5 249.423 256.899 230.634 260.801C190.715 63.1322 383.438 120.979 413.028 -13.0876C413.028 112.463 366.817 95.0285 295.999 162.804Z"
        fill={colors[4]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"
        />
    <path id="Vector 22" d="M288.999 36.5C350.632 17.9617 390.168 -30.9691 398.388 -65.025C415.224 68.5195 221.665 81.6043 230.632 260.802C219.999 241.5 203.75 181.422 205.499 145C207.249 108.579 212.415 59.5358 288.999 36.5Z"
    fill={colors[3]}
    {stroke}
    stroke-width={strokeWidth}
    stroke-linejoin="round"
    stroke-linecap="round"/>
    <path id="Vector 24" d="M340.008 -44.2236C340.008 69.5505 151.483 65.9696 230.633 260.801L230.21 260.419C187.365 221.643 170.545 206.421 168.87 134.164C163.703 22.4851 296.869 33.1457 340.008 -44.2236Z"
    fill={colors[4]}
    {stroke}
    stroke-width={strokeWidth}
    stroke-linejoin="round"
    stroke-linecap="round"/>
    <path id="Vector 23" d="M145.276 204.012C97.1883 109.446 183.537 79.785 183.538 1.92009C210.066 83.9046 131.94 174.719 230.634 260.801C207.024 260.214 160.292 233.542 145.276 204.012Z" 
    fill={colors[3]}
    {stroke}
    stroke-width={strokeWidth}
    stroke-linejoin="round"
    stroke-linecap="round"/>
    </g>
    <!-- <path
        d="M298.5 153.5C275.556 173.504 242.5 240.5 230.633 260.801C230.633 260.801 240.117 178.474 276.5 130C313.5 91.5 329.5 102.947 360.5 70.3397C393.492 35.637 423.06 -16.9882 423.989 -38.0379C423.971 -38.8868 423.959 -39.7081 423.954 -40.5005C424.017 -39.7368 424.028 -38.9148 423.989 -38.0379C424.386 -18.8684 427.559 14.3172 415.783 43.6984C392.388 102.067 327.181 128.496 298.5 153.5Z"
        fill={colors[4]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"
    />
    <path
        id="Vector 22"
        d="M289 36.5C353.593 27.4609 393.585 -31.389 410.672 -61.1697C406.322 -34.1565 377.837 41.4896 283.593 91.5001C228 121 230.633 260.802 230.633 260.802C220 241.5 203.75 181.422 205.5 145L205.525 144.475C207.276 107.995 210.177 47.5305 289 36.5Z"
        fill={colors[5]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"
    />
    <path
        id="Vector 23"
        d="M185.428 137.739C184.795 178.518 210.512 235.248 230.633 260.801C207.023 260.214 175.426 225.886 163.636 194.927C145.279 146.726 150 61 150 61C150 61 164.15 108.97 169.837 120.734C169.55 114.528 164.747 79.3478 188.549 50.9623C208.345 27.3538 220.29 21.0895 247.225 13.2348C274.16 5.37999 348.811 -30.2926 351.441 -39.187C339.319 4.02163 269.076 18.9522 238.709 33.0365C203.361 49.4314 186.141 91.8661 185.428 137.739Z"
        fill={colors[3]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"
    /> -->
{/if}

{#if selection == "Q"}
    <g id="hair5">
        <path
            d="M231.712 273.893C272.619 220.318 345.645 182.293 280.151 135.213C305.471 154.556 295.72 190.256 272.271 212.059C252.131 229.583 239.907 259.969 231.712 273.893Z"
            fill={colors[3]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
    </g>
    <g id="hair2">
        <path
            d="M151.622 203.31C151.622 203.31 127.325 223.423 114.126 248.929C128.34 189.868 131.243 162.106 189.189 130.385C229.276 117.018 249.71 116.276 280.15 135.212C197.152 142.972 151.622 203.31 151.622 203.31Z"
            fill={colors[4]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
    </g>
    <g id="hair3">
        <path
            d="M113.591 290.928C115.671 258.335 151.624 203.31 151.624 203.31C188.639 139.445 216.225 122.964 280.151 135.212C318.126 168.947 208.188 209.974 186.844 217.193C145.824 231.065 121.35 268.63 113.591 290.928Z"
            fill={colors[3]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
    </g>
    <g id="hair4">
        <path
            d="M139.992 273.294C150.166 247.944 167.542 223.72 186.843 217.193C231.307 194.661 256.031 181.787 280.15 135.212C305.47 154.555 295.719 190.256 272.27 212.059C258.401 224.955 238.713 235.256 216.114 240.545C155.308 254.774 142.168 268.084 139.992 273.294Z"
            fill={colors[4]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
    </g>
    <g id="hair1">
        <path
            d="M225.632 105.493C236.918 105.411 270.374 106.953 280.151 135.213C249.711 116.277 229.278 117.018 189.19 130.385C173.865 134.407 166.078 134.924 154.206 131.195C183.155 123.733 195.988 105.707 225.632 105.493Z"
            fill={colors[3]}
            {stroke}
            stroke-width={strokeWidth}
            stroke-linejoin="round"
            stroke-linecap="round"
        />
    </g>
{/if}

{#if selection == "R"}
    <g id="hair-18" />
{/if}

{#if selection == "S"}
<g id="Hair">
    <g>
    <path d="M75.6758 133.766C122.64 127.891 196.468 88.4291 248.292 115.407C300.116 142.386 293.854 196.104 262.199 216.379C256.752 120.375 116.424 147.801 75.6758 133.766Z"
        fill={colors[3]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"/>
    
    </g>
    <g>
    <path d="M195 119.182C246.974 131.787 276.23 185.51 262.199 216.379C108.82 74.7659 60.4266 241.823 -34.3711 284.25C39.2131 200.059 17.3366 76.0917 195 119.182Z"
    fill={colors[4]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"/>

    
    </g>
    <g>
    <path d="M262.201 216.379C237.596 190.795 186.502 173.687 144.976 185.51C18.1379 221.62 109.005 389.638 30.0908 492.492C55.126 357.172 8.49013 272.129 30.0906 220.609C62.1272 121.201 200.259 113.326 262.201 216.379Z"
    fill={colors[3]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"/>
    
    </g>
    <g>
    <path d="M102.401 566.186C122.862 433.331 46.807 380.947 51.6609 298.232C58.36 184.161 180.312 122.519 262.2 216.379C204.604 185.51 157.336 215.652 134.679 268.476C89.635 373.466 196.256 469.953 102.401 566.186Z" 
    fill={colors[4]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"/>
    
    </g>
    <g>
    <path d="M141.486 364.602C146.808 449.051 118.367 472.996 118.367 472.996C118.367 472.996 126.198 440.566 125.335 421.134C122.911 366.598 92.5174 143.758 260.61 215.838C179.204 195.285 136.164 280.153 141.486 364.602Z"
    fill={colors[3]}
        {stroke}
        stroke-width={strokeWidth}
        stroke-linejoin="round"
        stroke-linecap="round"/>/>
    
    </g>
    </g>
    
{/if}

{#if selection == "T"}
    <g id="Hair">
        <g id="hair5">
            <path
                d="M174.422 283.021C165.782 216.17 121.552 146.727 201.812 138.701C170.213 142.792 160.808 178.585 170.213 209.192C178.894 234.438 174.287 266.865 174.422 283.021Z"
                fill={colors[4]}
                {stroke}
                stroke-width={strokeWidth}
                stroke-linejoin="round"
                stroke-linecap="round"
            />
        </g>
        <g id="hair2">
            <path
                d="M279.071 261.939C279.071 261.939 290.057 291.505 288.735 320.194C305.955 261.939 317.322 236.445 283 180C254.967 148.38 237.642 137.521 201.812 138.701C269.811 186.92 279.071 261.939 279.071 261.939Z"
                fill={colors[3]}
                {stroke}
                stroke-width={strokeWidth}
                stroke-linejoin="round"
                stroke-linecap="round"
            />
        </g>
        <g id="hair3">
            <path
                d="M268.201 356.835C282.696 327.568 279.072 261.939 279.072 261.939C278.948 188.123 263.299 160.057 201.813 138.701C152.059 148.928 226.754 239.428 241.629 256.352C270.217 288.875 272.63 333.644 268.201 356.835Z"
                fill={colors[4]}
                {stroke}
                stroke-width={strokeWidth}
                stroke-linejoin="round"
                stroke-linecap="round"
            />
        </g>
        <g id="hair4">
            <path
                d="M254.153 328.362C258.017 301.321 255.08 271.655 241.629 256.352C214.388 214.606 199.414 191.095 201.813 138.701C170.214 142.792 160.808 178.585 170.214 209.192C175.777 227.294 187.677 246.06 204.603 261.939C250.148 304.665 254.873 322.762 254.153 328.362Z"
                fill={colors[3]}
                {stroke}
                stroke-width={strokeWidth}
                stroke-linejoin="round"
                stroke-linecap="round"
            />
        </g>
        <g id="hair1">
            <path
                d="M263.887 140.222C254.154 134.508 224.41 119.115 201.813 138.701C237.642 137.521 254.968 148.38 283.001 180C294.262 191.145 300.747 195.486 312.893 198.194C291.554 177.256 289.453 155.229 263.887 140.222Z"
                fill={colors[4]}
                {stroke}
                stroke-width={strokeWidth}
                stroke-linejoin="round"
                stroke-linecap="round"
            />
        </g>
    </g>
{/if}

{#if selection == "U"}
    
<g/>
    
{/if}

{#if selection == "V"}
    <g id="frame">
        <circle
            id="circle_2"
            cx="229.75"
            cy="220"
            r="40"
            fill={colors[2]}
            {stroke}
            stroke-width={strokeWidth}
        />
        <g transform="translate(200 190)">
            <Symbol symbol="F" symbolColor={stroke} />
        </g>
    </g>
{/if}
{#if selection == "W"}
    <g />
{/if}

{#if selection == "X"}
<path  d="M162.224 140.776C186.624 170.512 121.05 233.798 233.842 270.697C196.388 205.661 216.513 161.614 162.224 140.776Z"  fill="{colors[4]}" {stroke} stroke-width={strokeWidth} stroke-linejoin="round" />
<path  d="M182.325 104.147C250.846 143.158 111.322 203.573 233.841 270.697C177.259 222.146 299.861 125.653 182.325 104.147Z" fill="{colors[3]}" {stroke} stroke-width={strokeWidth} stroke-linejoin="round" />
<path  d="M303.674 119.302C257.894 162.4 311.877 228.501 233.842 270.697C199.238 205.551 252.753 119.302 303.674 119.302Z"   fill="{colors[4]}" {stroke} stroke-width={strokeWidth} stroke-linejoin="round" />
<path  d="M250.917 55.9028C200.974 113.558 351.877 111.149 233.841 270.697C265.573 202.101 159.476 131.552 250.917 55.9028Z" fill="{colors[3]}" {stroke} stroke-width={strokeWidth} stroke-linejoin="round" />
<path  d="M239.842 116.65C243.845 188.172 164.321 218.181 233.84 270.697C227.339 237.187 293.358 166.165 239.842 116.65Z"    fill="{colors[4]}" {stroke} stroke-width={strokeWidth} stroke-linejoin="round" />
<path  d="M319.686 152.296C278.04 186.761 283.784 249.469 233.842 270.697C212.46 192.984 281.869 141.765 319.686 152.296Z"   fill="{colors[3]}" {stroke} stroke-width={strokeWidth} stroke-linejoin="round" />
<path  d="M324.408 183.636C274.786 205.72 310.193 274.133 233.841 270.697C230.33 222.399 289.789 173.313 324.408 183.636Z"   fill="{colors[4]}" {stroke} stroke-width={strokeWidth} stroke-linejoin="round" />

{/if}

{#if selection == "Y"}
    <g />
{/if}

{#if selection == "Z" && symbol != "0"}
    <g id="frame">
        <circle
            id="circle_2"
            cx="229.75"
            cy="220"
            r="40"
            fill={colors[2]}
            {stroke}
            stroke-width={strokeWidth}
        />
        <g transform="translate(200 190)">
            <Symbol bind:symbol symbolColor={stroke} />
        </g>
    </g>
{/if}


{#if selection == "0"}

<g transform="translate(-10,50)">
    <path id="Vector 2" d="M398.197 144.847C387.693 137.51 184.496 96.2347 75.404 141.474C49.989 152.013 64.1032 218.507 97.4214 208.851C130.74 199.195 345.525 207.669 380.616 215.094C415.708 222.518 408.7 152.185 398.197 144.847Z" fill="white" {stroke} stroke-width={strokeWidth}/>

    <path d="M142.684 41.2117C142.684 41.2117 95.5403 101.611 82.4104 138.041C180.877 121.855 161.551 112.938 271.084 125.881C291.088 165.033 322.951 460.312 330.758 494.762C338.697 495.806 381.388 225.551 368.171 135.103L391.665 141.323C392.303 117.765 378.005 78.8588 351.246 54.1303C345.392 34.8975 338.58 19.5029 330.758 10.3793C295.755 -2.15397 257.818 -12.5878 221.54 -11.7174C185.262 -10.8471 142.684 41.2117 142.684 41.2117Z" fill="#cc0000"/>
    <path d="M271.084 125.881C291.088 165.033 322.951 460.312 330.758 494.762C338.697 495.806 381.388 225.551 368.171 135.103M271.084 125.881C161.551 112.938 180.877 121.855 82.4104 138.041C95.5403 101.611 142.684 41.2117 142.684 41.2117C142.684 41.2117 185.262 -10.8471 221.54 -11.7174C257.818 -12.5878 295.755 -2.15397 330.758 10.3793C347.9 30.3727 360.19 80.4812 368.171 135.103M271.084 125.881C264.594 113.178 259.986 104.308 256.421 98.068M351.245 54.1301C378.005 78.8586 392.303 117.765 391.665 141.323L368.171 135.103" {stroke} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round"/>

    <path id="Ellipse 2.2" d="M331.76 464.463C331.76 464.463 316.023 473.158 310.851 479.252C306.349 484.555 301.358 499.174 301.358 499.174C301.358 499.174 306.787 515.058 311.921 520.479C317.031 525.875 329.637 532.022 329.637 532.022C329.637 532.022 345.602 526.371 350.586 521.693C356.432 516.207 363.398 499.665 363.398 499.665C363.398 499.665 356.599 482.697 350.985 477.225C345.953 472.321 331.76 464.463 331.76 464.463Z" fill="white" {stroke} stroke-width={strokeWidth}/>
    
    <path id="Vector_2" d="M193.652 71.1284C193.652 71.1284 183.005 -3.05362 87.0757 -21.9585C56.4463 -27.9947 37.8995 -16.559 7.27153 -22.6025C-7.82413 -25.5812 -31.3791 -41.0766 -31.3791 -41.0766C-31.3791 -41.0766 -10.0539 -10.3784 7.44621 -1.73396C32.1572 10.4724 45.3906 6.88463 71.7141 15.2509C152.764 41.0107 134.778 86.8946 134.778 86.8946C134.861 96.844 144.52 116.629 170.649 105.683C193.86 95.9593 194.899 76.4196 193.652 71.1284Z" 
    fill="url(#hornGradient{hash})" {stroke} stroke-width={strokeWidth}/>
<path id="Vector_3" d="M498.742 -22.6025C468.114 -16.559 449.567 -27.9947 418.938 -21.9585C379.304 -14.1478 354.228 3.09863 338.445 20.6507C353.294 53.4787 357.876 71.7868 362.787 104.358C368.679 99.5455 371.194 91.9503 371.236 86.8946C371.236 86.8946 353.249 41.0107 434.3 15.2509C460.623 6.88463 473.856 10.4724 498.567 -1.73396C516.068 -10.3784 537.393 -41.0766 537.393 -41.0766C537.393 -41.0766 513.838 -25.5812 498.742 -22.6025Z" 
fill="url(#hornGradient{hash})" {stroke} stroke-width={strokeWidth}/>

    
    

</g>

{/if}